module.exports = __webpack_public_path__ + "static/media/freecodecamp_logo.d1c23cc9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/freecodecamp_logo.svg
// module id = 183
// module chunks = 0